function createCookie(name,value,days) {

    var expires = "";

    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    document.cookie = name+"="+value+expires+"; path=/;";
}

function deleteCookie(name) {
    document.cookie = name+"=; Max-Age=-99999999; path=/;";
}

function readCookie(k){
    return(document.cookie.match('(^|; )'+k+'=([^;]*)')||0)[2];
}